import { types as sdkTypes } from './util/sdkLoader';

const { LatLng, LatLngBounds } = sdkTypes;

// An array of locations to show in the LocationAutocompleteInput when
// the input is in focus but the user hasn't typed in any search yet.
//
// Each item in the array should be an object with a unique `id` (String) and a
// `predictionPlace` (util.types.place) properties.
export default [
  {
    id: 'default-rome',
    predictionPlace: {
      address: 'Roma, Italia',
      origin: new LatLng(41.9027835, 12.4963655),
      bounds: new LatLngBounds(new LatLng(42.88536277174289, 13.916893760934547), new LatLng(40.91905378746772, 11.196151127677114)),
      city: 'Roma',
    },
  },
  {
    id: 'default-milan',
    predictionPlace: {
      address: 'Milano, Italia',
      origin: new LatLng(45.4642035, 9.189982),
      bounds: new LatLngBounds(new LatLng(45.97073197818757, 9.973084486996893), new LatLng(44.94942367899926, 8.396369955713038)),
      city: 'Milano',
    },
  },
  {
    id: 'default-naples',
    predictionPlace: {
      address: 'Napoli, Italia',
      origin: new LatLng(40.8517746, 14.2681244),
      bounds: new LatLngBounds(new LatLng(41.285542678186296, 15.001228386007977), new LatLng(40.41756836174917, 13.50159923101026)),
      city: 'Napoli',
    },
  },
];



// WEBPACK FOOTER //
// ./src/default-location-searches.js